import { getErrorMsg } from './error';
import store from '@/store'


/**
 * 没有权限错误页处理
 * @returns {Object}
 */
function toErrorPage(data) {
    let pageMessage = store.state.pageMessage || {};
    if(!pageMessage.code) {
        console.log('toErrorPage........inner')
        store.commit('meta', {
            initialized: false,
            pageMessage: getErrorMsg(data)
        });
    }
    console.log('toErrorPage........outer')
}

export {
    toErrorPage
}